import type { SVGProps } from 'react';

const PendingPtoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        width="16"
        height="16"
        rx="8"
        fill="#F79009"
      />
      <path
        d="M12.6665 5.33073L9.99984 7.9974H11.9998C11.9998 10.2041 10.2065 11.9974 7.99984 11.9974C7.3265 11.9974 6.6865 11.8307 6.13317 11.5307L5.15984 12.5041C5.97984 13.0241 6.95317 13.3307 7.99984 13.3307C10.9465 13.3307 13.3332 10.9441 13.3332 7.9974H15.3332L12.6665 5.33073ZM3.99984 7.9974C3.99984 5.79073 5.79317 3.9974 7.99984 3.9974C8.67317 3.9974 9.31317 4.16406 9.8665 4.46406L10.8398 3.49073C10.0198 2.97073 9.0465 2.66406 7.99984 2.66406C5.05317 2.66406 2.6665 5.05073 2.6665 7.9974H0.666504L3.33317 10.6641L5.99984 7.9974H3.99984Z"
        fill="#6C737F"
      />
    </svg>
  );
};

export default PendingPtoIcon;
